import React from 'react'
import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'
import { Form, Alert, Box } from '@smooth-ui/core-sc'
import useInputValue from '@rehooks/input-value'

import trackGMT from 'helpers/gtm'
import PageWrapper from 'components/PageWrapper/PageWrapper'
import {
  PageTitle,
  SpinnerButton,
  GrayBox,
  FormField
} from 'components/Elements/index'
import config from 'config'

const name = 'Glemt passord'

const forgotMutation = gql`
  mutation requestPasswordReset($email: String!) {
    requestPasswordReset(email: $email) {
      success
      message
    }
  }
`

const ForgotPassword = ({ history: { replace } }) => {
  const email = useInputValue('')
  const [requestPasswordReset, { data, loading, error }] = useMutation(
    forgotMutation
  )
  const onSubmit = async event => {
    event.preventDefault()
    try {
      const {
        data: { requestPasswordReset: payload }
      } = await requestPasswordReset({
        variables: {
          email: email.value.trim()
        }
      })
      trackGMT({
        event: 'custom',
        category: 'Forgot password',
        action: payload.message || 'Success'
      })
    } catch (error) {
      trackGMT({
        event: 'custom',
        category: 'Forgot password',
        action: 'Error',
        label: `${error.message} (${email.value.trim()})`
      })
    }
  }
  return (
    <PageWrapper title={name}>
      <Box width={{ sm: 1, md: 0.5 }} mx="auto">
        <PageTitle>{name}</PageTitle>
        {error && (
          <Alert variant="danger">
            Feil: Fant ikke noen bruker med den e-posten
          </Alert>
        )}
        {data ? (
          <Alert variant="success">
            Vi har sendt deg en e-post hvor du finner info om å endre passord
          </Alert>
        ) : (
          <GrayBox>
            <Form onSubmit={onSubmit} mb={2}>
              <FormField
                name="email"
                placeholder={`E-post ${
                  config.enableUsernameLogin ? ' eller brukernavn' : ''
                }`}
                inputMode="email"
                autoComplete="email"
                field={email}
                autoCapitalize="none"
              />
              <SpinnerButton
                working={loading}
                text="Nullstill passord"
                type="submit"
                alignItems="center"
                justifyContent="center"
                width="100%"
              />
            </Form>
          </GrayBox>
        )}
      </Box>
    </PageWrapper>
  )
}

export default ForgotPassword
